import React from 'react';
import Box from '@mui/material/Box';
import FilterSelect from '../FilterSelect';
import SearchField from '../SearchField';
import { filterBarSx } from '../filterStyles';

const STATUS_OPTIONS = [
  { value: 'all', label: 'Todas as situações' },
  { value: 'sent', label: 'Enviado' },
  { value: 'pending', label: 'Pendente' },
  { value: 'failed', label: 'Falha' },
  { value: 'skipped', label: 'Ignorado' },
];

const OPENED_OPTIONS = [
  { value: '', label: 'Abriu ou não' },
  { value: 'sim', label: 'Abriu' },
  { value: 'nao', label: 'Não abriu' },
];

const CLICKED_OPTIONS = [
  { value: '', label: 'Clicou ou não' },
  { value: 'sim', label: 'Clicou' },
  { value: 'nao', label: 'Não clicou' },
];

/**
 * Busca e filtros da lista de destinatários de um envio.
 * @param {{ filters: { status, opened, clicked }, onFilterChange: Function, searchInput: string, onSearchInputChange: Function }} props
 */
function EditionRecipientsFilters({ filters, onFilterChange, searchInput, onSearchInputChange }) {
  return (
    <Box sx={filterBarSx}>
      <SearchField value={searchInput} onChange={onSearchInputChange} placeholder="Buscar por nome, e-mail ou empresa" />
      <FilterSelect value={filters.status} options={STATUS_OPTIONS} onChange={(value) => onFilterChange('status', value)} />
      <FilterSelect value={filters.opened} options={OPENED_OPTIONS} onChange={(value) => onFilterChange('opened', value)} />
      <FilterSelect value={filters.clicked} options={CLICKED_OPTIONS} onChange={(value) => onFilterChange('clicked', value)} />
    </Box>
  );
}

export default EditionRecipientsFilters;
